import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StraziComponent } from './strazi.component';
import { AddStraziComponent } from './add-strazi/add-strazi.component';
import { EditStraziComponent } from './edit-strazi/edit-strazi.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
    declarations: [
        StraziComponent,
        AddStraziComponent,
        EditStraziComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [StraziComponent]
})
export class StraziModule { }
